import styled from 'styled-components';
import React, {useRef, useState} from 'react';
import { Form, message, Button,Tabs, } from 'antd';
import { submitConversation } from '../../../api/Report';
import { CustomInputTextarea } from '../../../components/CustomForm';
import MarkdownIt from 'markdown-it';
import {MarkdownEditor} from "../../../components/MarkdownEditor";
import FilesUpload from "../../AddReport/components/FilesUpload";

const DialogueReplyContainer = styled.div`
  width: 100%;
`;
const UploadWrap = styled.div`
  padding-top: 20px;
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 20px;
`;

const DialogueReply = ({ onRefresh, serial_number }) => {
    const [ReplyContent, setReplyContent] = useState('');
    const [filesArray, setFilesArray] = useState([]);
    const filesUploadRef = useRef(null);
    const { TabPane } = Tabs;

    const submitReply = async () => {
        if (!ReplyContent.trim()) return message.error('Please enter a reply');
        try {
            const { code } = await submitConversation({
                serial_number: serial_number,
                content: ReplyContent,
                attachmentIds: filesArray
            });
            if (code === '10000') {
                setReplyContent('');
                filesUploadRef.current?.clearFiles();
                onRefresh();
                message.success('Reply successfully');
            }
        } catch (error) {
            // console.log(error);
        }
    };

    const onFilesUploaded = (filesList) => {
        let files = filesList
            .filter((_file) => _file.response && _file.response.data)
            .map((item) => item.response.data.file_id);
        setFilesArray(files);
    };
    return (
        <DialogueReplyContainer>
            {/* <CustomInputTextarea
        value={ReplyContent}
        rows={4}
        onChange={(e) => {
          setReplyContent(e.target.value);
        }}
      /> */}
            <Tabs
                type="card"
                tabPosition={'bottom'}
                tabBarGutter={0}
                tabBarStyle={{
                    marginTop: 0,
                }}
                style={{
                    color:'#fff'
                }}
            >
                <TabPane
                    tab="Write"
                    key="1"
                    style={{
                        flex: 1,
                        width: '100%',
                    }}
                >
                    <div>
                        <MarkdownEditor
                            mode={1}
                            value={ReplyContent}
                            height={300}
                            onChange={({text, html}) => setReplyContent(text)}
                        />
                    </div>
                </TabPane>
                <TabPane tab="Preview" key="2">
                    <MarkdownEditor
                        mode={2}
                        value={ReplyContent}
                        height={200} />
                </TabPane>
            </Tabs>
            <UploadWrap>
                <FilesUpload ref={filesUploadRef} onFilesUploaded={onFilesUploaded} />
            </UploadWrap>
            <ButtonContainer>
                <Button
                    type="primary"
                    style={{
                        height: '42px',
                        backgroundColor: '#18EAC4',
                        borderColor: '#18EAC4',
                        color: '#000',
                        borderRadius: '6px',
                    }}
                    onClick={submitReply}>
                    Post
                </Button>
            </ButtonContainer>
        </DialogueReplyContainer>
    );
};

export default DialogueReply;
